
import React from "react";
import PropTypes from "prop-types";
import { getLocalStorage } from "global/utilities/browserStorage";
import { Input, Button } from "reactstrap";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { constructGetArchetypeNamesUrl, constructGetArchetypeVariationNamesUrl } from "api";
import { metagameArchetypeNamingSchema } from "apiSchemas";

export async function loadArchetypeName(archetype) {
	const url = constructGetArchetypeNamesUrl(archetype.archetypeId);
	const response = await fetch(url);
	const data = await response.json();
	return data;
}

export async function loadArchetypeVariationName(archetype, variation) {
	const url = constructGetArchetypeVariationNamesUrl(archetype.archetypeId, variation.archetypeVariationId);
	const response = await fetch(url);
	const data = await response.json();
	return data;
}

async function saveArchetypeName(archetypeId, archetypeVariationId, naming) {
	const adminToken = getLocalStorage("adminToken");
	const url = constructGetArchetypeVariationNamesUrl(archetypeId, archetypeVariationId);
	const options = {
		method: "PUT",
		headers: {
			"Security-Token": adminToken
		},
		body: JSON.stringify(naming),
	};

	await fetch(url, options);
}

EditArchetypeNamesDialog.propTypes = {
	archetypeNaming: PropTypes.shape(metagameArchetypeNamingSchema),
	setArchetypeNaming: PropTypes.func.isRequired,
	isDialogOpen: PropTypes.bool,
	setIsDialogOpen: PropTypes.func.isRequired
};

export function EditArchetypeNamesDialog({ archetypeNaming, setArchetypeNaming, isDialogOpen, setIsDialogOpen }) {
	const isDebugModeEnabled = getLocalStorage("isDebugModeEnabled") == "true";
	const archetypeTextBoxReference = React.createRef();
	const variationTextBoxReference = React.createRef();
	const save = async () => {
		var newNaming = {
			archetypeCustomDisplayName: archetypeTextBoxReference.current.value,
			archetypeVariationCustomDisplayName:
				archetypeNaming.hasSingleVariation ?
					archetypeTextBoxReference.current.value :
					variationTextBoxReference.current.value,
		};

		console.log(newNaming);

		await saveArchetypeName(
			archetypeNaming.archetypeId, archetypeNaming.archetypeVariationId, newNaming);

		closeDialog();
	};

	const closeDialog = () => {
		setArchetypeNaming(null);
		setIsDialogOpen(false);
	};

	return (isDebugModeEnabled &&
		<Modal isOpen={isDialogOpen} toggle={closeDialog}>
			<ModalHeader toggle={closeDialog}>Edit Archetype Name</ModalHeader>
			<ModalBody>
				{archetypeNaming ?
					<>
						<Input
							id="archetypeName"
							innerRef={archetypeTextBoxReference}
							defaultValue={archetypeNaming.archetypeCustomDisplayName} />

						<Input
							id="variationName"
							innerRef={variationTextBoxReference}
							defaultValue={archetypeNaming.archetypeVariationCustomDisplayName}
							readOnly={archetypeNaming.hasSingleVariation} />

						<ul>
							{archetypeNaming.archetypeDisplayNames && archetypeNaming.archetypeDisplayNames.map(pair =>
								<li key={pair.name}>{pair.name} ({pair.count})</li>
							)}
						</ul>
					</> : <span>Loading...</span>
				}
			</ModalBody>

			<ModalFooter>
				<Button color="primary" onClick={save}>
					Save
				</Button>
				{" "}
				<Button color="secondary" onClick={closeDialog}>
					Cancel
				</Button>
			</ModalFooter>
		</Modal>
	);
}